export default __webpack_public_path__ + "static/media/dole-juice-module-hero.5e6f619c.png";